import { withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { connect } from 'formik';
import * as _ from 'lodash';
import * as moment from 'moment';
import propTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { getDateFormatByLocale } from '../../utils/date-utils';
import { getErrorLabelForPath, pathHasError } from '../../utils/form-utils';

const KeyboardDatePickerWithFormik = ({
  classes,
  formik,
  name,
  t,
  i18n: { language },
  tReady,
  textFieldProps,
  ...props
}) => {
  const dateFormat = getDateFormatByLocale(language);

  const error = pathHasError(name, formik.touched, formik.errors);
  const helperText = getErrorLabelForPath(
    name,
    formik.touched,
    formik.errors,
    t
  );
  const currentValue = _.get(formik.values, name);

  const touch = () => formik.setFieldTouched(name);
  const onChange = e => {
    // Para detectar cuando se borra todo
    // eslint-disable-next-line no-underscore-dangle
    formik.setFieldValue(name, e && e._i === '__/__/____' ? null : e);
  };
  const placeholder = props.placeholder || '01/01/2020';
  const innerProps = {
    format: dateFormat,
    name,
    value: currentValue,
    minDate: moment('1900-01-01'),
    placeholder,
    inputVariant: 'outlined',
    okLabel: t('general.ok'),
    cancelLabel: t('general.cancel'),
    todayLabel: t('general.hoy'),
    showTodayButton: true,
    clearable: !props.required,
    clearLabel: t('general.borrar'),
    error,
    helperText: helperText || ' ',
    onOpen: touch,
    onChange,
    onFocus: touch,
    InputLabelProps: {
      shrink: true
    },
    InputAdornmentProps: { position: 'start' },
    style: { width: '100%' }
  };
  const datePickerProps = { ...innerProps, ...props };
  return <KeyboardDatePicker {...datePickerProps} />;
};

KeyboardDatePickerWithFormik.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string
};

KeyboardDatePickerWithFormik.defaultProps = {
  textFieldProps: {}
};

const styles = () => ({
  input: {}
});

export default withStyles(styles)(
  withTranslation()(connect(KeyboardDatePickerWithFormik))
);
